import { render, staticRenderFns } from "./GameInfoModal.vue?vue&type=template&id=1e08f2c6&scoped=true&"
import script from "./GameInfoModal.vue?vue&type=script&lang=js&"
export * from "./GameInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./GameInfoModal.vue?vue&type=style&index=0&id=1e08f2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e08f2c6",
  null
  
)

export default component.exports